var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Hey we are working on it. Come back soon and we promise to get forgot password configured.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }